export default [
{ title: 'Home', url: '/' }];